import { arweaveBlocksQuery } from "./arweave/blocks.js";
import { arweaveTransactionsQuery } from "./arweave/transactions.js";
import { irysTransactionsQuery } from "./irys/transactions.js";
// import { arweaveTransactionQuery } from "./arweave/transaction.js";
// import { arweaveBlockQuery } from "./arweave/block.js";
// map query names to queries
export const queries = {
    "irys:transactions": irysTransactionsQuery,
    "arweave:transactions": arweaveTransactionsQuery,
    "arweave:blocks": arweaveBlocksQuery,
    // "arweave:transaction": arweaveTransactionQuery,
    // "arweave:block": arweaveBlockQuery,
};
//# sourceMappingURL=index.js.map